import React from "react";
import "../css/particles.css";

const Particles: React.FC = () => {
  return (
    <div className="particles-container">
      <div className="particle" />
      <div className="particle" />
      <div className="particle" />
      <div className="particle" />
      <div className="particle" />
      <div className="particle" />
      <div className="particle-glow" />
    </div>
  );
};

export default Particles;
